// extracted by mini-css-extract-plugin
module.exports = {"base":"JobListingTable_base__JNS09","actionButton":"JobListingTable_actionButton__Na_hv"};